var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubstractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 105,
    viewBox: "0 0 88 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_5994_8619)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5994_8619",
    patternContentUnits: "objectBoundingBox",
    width: 2,
    height: 2
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5994_8619",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5994_8619",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACMUlEQVR4nO2dzW1UQRCE3wnn8Mq++cRPFtMyCRCWLYzMjEiBGMBJAIFg+2gL1DculpCsnWrNfp9U552u6u7Z05ttAwAAAAAAAAAA+E9O25d3exvXexs/1fqDYvxZWq0/ZK179I+n0d/aGuX8/fWJYnS18WQ3JVxhjCe1/vn1h6+vppu/t3FrNyBqaG/j+9QQFH24i1Y1tXEzbecf9dqJ5wLoj2cXN28OHkBeuPZio6b21q8OHoCi/3IXqqLa2/gxIYBx7y5UVdX63YwA/IVGXRFAEIC9C8UE+I0QK8hvhgziDggCsHehmAC/EWIF+c2QQdwBQQD2LhQT4DdCrCC/GTKIOyAIwN6FYgL8RogV5DdDBnEHBAHYu1BMgN8IsYL8Zsgg7oAgAHsXignwGyFWkGlHvpDl74CtOKpeX/kDrl5f+QOuXl/5A65eX/kDrl5f+QOuXl/5A65e30sPuLo2AhgE4O5CMQF+I8QK8pshg7gDggDsXSgmwG+EWEF+M2QQd0AQgL0LxQT4jRAryG+GDOIOCAKwd6GYAL8RYgX5zZBB3AFBAPYuFBPgN0KsIL8ZMog7IAjA3oViAvxGaOEVxIdb45kA2vg9IQA+XSznp4vz5Qj3mKuqWr88eAD5bEd+qt1ebBzp5+uTfLbDXnDU0h790zaLfK4jn+1wF60y6t+mvyOTP5jPdhz1Omr9MTt/uvn/knsvX47IfwBH8hf1PmvNmqftfAAAAAAAAAAA2FbgL+V77kr0XknCAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstractIcon);
export default __webpack_public_path__ + "static/media/substract_icon.0d1cde37b6410269d2a984ad196ad063.svg";
export { ForwardRef as ReactComponent };